// src/frontend_react/src/components/ui/Icon/Icon.js
import React from 'react';
import styles from './Icon.module.css';

const Icon = ({
  as,
  children,
  size = 'md',
  color,
  className = '',
  title,
  isDecorative = !title,

  style,
  alignSelf,
  flexGrow,
  mt, mb, ml, mr,
  ...rest
}) => {
  const IconComponent = as;
  const iconContent = IconComponent ? <IconComponent /> : children;

  const sizeClass = styles[size] || (styles[`size-${size}`] || ''); // Handle sizes like 'h1'
  const colorClass = color && styles[`color-${color}`] ? styles[`color-${color}`] : '';
  
  const finalStyle = { ...style };
  
  // Handle numeric or custom string sizes for font-size
  if (typeof size === 'string' && (size.includes('px') || size.includes('em') || size.includes('rem'))) {
    finalStyle.fontSize = size;
  }
  
  // Handle custom color strings
  if (color && !styles[`color-${color}`] && color !== 'inherit') {
    finalStyle.color = color;
  }

  // Apply layout props
  const getSpacingValue = (v) => typeof v === 'number' ? `calc(var(--cipher-spacing-unit) * ${v})` : v;
  if (alignSelf) finalStyle.alignSelf = alignSelf;
  if (flexGrow) finalStyle.flexGrow = flexGrow;
  if (mt !== undefined) finalStyle.marginTop = getSpacingValue(mt);
  if (mb !== undefined) finalStyle.marginBottom = getSpacingValue(mb);
  if (ml !== undefined) finalStyle.marginLeft = getSpacingValue(ml);
  if (mr !== undefined) finalStyle.marginRight = getSpacingValue(mr);

  return (
    <span
      className={`${styles.iconWrapper} ${sizeClass} ${colorClass} ${className}`}
      style={finalStyle}
      aria-hidden={isDecorative ? 'true' : undefined}
      title={title}
      {...rest}
    >
      {iconContent}
    </span>
  );
};

export default Icon;